module.exports = __webpack_public_path__ + "static/media/work1.f46109fa.jpg";